import { BannerService } from 'sat-core';

import btLogoSmall from '../img/ballard-tighe-logo.png';

BannerService.generateFooterLinkMap = () => {
  return new Map([
    ['termsOfUse', '/terms'],
    ['privacy', '/privacy']
  ]);
};

BannerService.generateFooterElements = () => {
  return [
    'logo',
    'contact',
    'separator',
    'phone', 
    'separator',
    'termsOfUse',
    'separator',
    'privacy'
  ];
};

BannerService.getLogoInfo = () => {
  return {
    logoImg: btLogoSmall,
    logoUrl: 'https://www.ballard-tighe.com/'
  };
};

BannerService.getContactInfo = () => {
  return {
    email: 'helpdesk-3@ballard-tighe.com',
    phone: '714-990-4332'
  };
};

BannerService.getCopyrightText = () => {
  return '©2025 Ballard & Tighe, Publishers, a division of Educational IDEAS, Inc. All rights reserved.';
}; 